import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, fetchAuthSession, signOut } from 'aws-amplify/auth';
import './AdminLoginPage.css';

const AdminLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const session = await fetchAuthSession();
        if (session.tokens?.idToken) {
          const groups = (session.tokens.idToken.payload['cognito:groups'] ?? []) as string[];
          if (groups.includes('Administrators')) {
            navigate('/admin', { replace: true });
          }
        }
      } catch {}
    })();
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn({ username: email, password });
      const session = await fetchAuthSession({ forceRefresh: true });
      const groups = (session.tokens?.idToken?.payload?.['cognito:groups'] ?? []) as string[];
      if (!groups.includes('Administrators')) {
        await signOut();
        setError('Access denied. This login is reserved for administrators.');
        setLoading(false);
        return;
      }
      navigate('/admin', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  return (
    <div className="al-page">
      <div className="al-card">
        <div className="al-header">
          <div className="al-icon">🛡️</div>
          <h1 className="al-title">Admin Access</h1>
          <p className="al-subtitle">Sign in with your administrator account</p>
        </div>
        <form className="al-form" onSubmit={handleSubmit}>
          <div className="al-field">
            <label className="al-label">Email</label>
            <input
              className="al-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
              autoFocus
            />
          </div>
          <div className="al-field">
            <label className="al-label">Password</label>
            <input
              className="al-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error && <div className="al-error">{error}</div>}
          <button className="al-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <div className="al-footer">
          <a className="al-register" href="/admin-register">Create an admin account</a>
          <a className="al-back" href="/">← Back to main site</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
